import { config } from "process"
import { Heading, TypographyType, TypographyColor, CustomDropdown, Chip, Body, BodyColor, BodyType } from "../../ui-elements"

interface Props {
    parameter: any;
    paramIndex: number
    index: number;
    selected: any;
    configParams: any;
    isParentChecked: boolean;
    toggleParam: (index: number, paramIndex: number) => void;
    handleParameterChange: (index: number, paramIndex: number, label: string, values: any[], options: any[]) => void;
    handleYearChange: (index: number, paramIndex: number, year: any) => void;
    toggleOptionSelection: (index: number, paramIndex: number, optionLabel: string) => void;
}

export const PresenceParameter: React.FC<Props> = ({ parameter, paramIndex, index, selected, configParams, isParentChecked, toggleParam, handleParameterChange, handleYearChange, toggleOptionSelection }) => {
    return (
        <div
            className="presence-type-width d-flex flex-column justify-content-start align-items-start gap-1"
            key={parameter?.param_name?.key}
        >
            <div className="d-flex flex-row gap-2 height-3vh">
                <input
                    type="checkbox"
                    id={`parameter-checkbox-${paramIndex}`}
                    className="width-1-3vw"
                    disabled={!isParentChecked}
                    checked={isParentChecked && selected && configParams?.includes(paramIndex)}
                    onChange={() => toggleParam(index, paramIndex)}
                />
                <Heading
                    title={parameter?.param_name?.label}
                    type={TypographyType.h6}
                    colour={TypographyColor.primary}
                    classname="text-nowrap line-height-14px"
                />
              
            </div>
            <div className="expanded-content d-flex flex-column justify-content-start align-items-start gap-2">
                <div className="d-flex w-100 gap-2">
                    <div className="d-flex flex-column">
                        <CustomDropdown
                            options={parameter?.values}
                            labelKey='label'
                            valueKey='label'
                            selectedValue={selected?.value?.label}
                            onSelect={(label) => handleParameterChange(index, paramIndex, label, parameter.values, parameter.options)}
                            name='year'
                            classname="custom-dropdown height-3vh header-icon ff-poppins-regular width-6-5vw "
                            disabled={!isParentChecked || !(selected?.selectedOptions?.length > 0)}
                        />
                    </div>
                    {selected?.value?.year?.length > 0 &&
                        <div className="d-flex flex-column">
                            <CustomDropdown
                                options={selected.value.year}
                                selectedValue={selected.year}
                                onSelect={(year) => handleYearChange(index, paramIndex, year)}
                                name='year'
                                classname="custom-dropdown height-3vh width-6-5vw   header-icon ff-poppins-regular"
                                disabled={!isParentChecked || !(selected?.selectedOptions?.length > 0)}
                            />
                        </div>
                    }
                </div>
                <div className="d-flex flex-wrap gap-2">
                    {parameter?.options?.map((option: any, optIndex: number) => {
                        const isSelected = !!selected?.selectedOptions?.includes(option.label);
                        return (
                            <Chip
                                key={optIndex}
                                label={option?.label}
                                iconUrl={option?.image}
                                selected={isParentChecked && selected && configParams?.includes(paramIndex) && isSelected}
                                disabled={!isParentChecked}
                                onClick={() => toggleOptionSelection(index, paramIndex, option.label)}
                            />
                        )
                    }
                    )}
                </div>
            </div>
        </div>
    )
}